<div class="detail-order-container row ml-0 mr-0">
  <div class="info-header" *ngIf="visualParams.isHeader">
    <div class="info-detail-header font-omicron-bold title-size-5">
      <span *ngIf="!visualParams.isPendingOrder">
        Detalle del pedido: #{{ header.transactionId | uppercase }}
      </span>
      <span class="detail-order-title title-size-5" *ngIf="visualParams.isPendingOrder">
        Detalle de la orden: #{{ header.transactionID | uppercase }}
      </span>
    </div>
    <div class="icon-close-dialog cursor-pointer" matDialogClose>
      <svg xmlns="http://www.w3.org/2000/svg" width="15.6" height="15.598" viewBox="0 0 15.6 15.598">
        <path
          d="M23.137,8.2a1.13,1.13,0,0,0-1.6,0l-5.866,5.866L9.8,8.2A1.131,1.131,0,0,0,8.2,9.8l5.866,5.866L8.2,21.537a1.131,1.131,0,0,0,1.6,1.6l5.863-5.863,5.866,5.866a1.131,1.131,0,1,0,1.6-1.6l-5.87-5.87L23.137,9.8A1.135,1.135,0,0,0,23.137,8.2Z"
          transform="translate(-7.873 -7.872)" />
      </svg>
    </div>
  </div>
  <div [ngClass]="
      visualParams.isHeader
        ? 'content-list-dialog  content-list-dialog-heigth row'
        : 'content-list-dialog  content-list-dialog-heigth-full row'
    ">
    <div class="isContentEmpty col-sm-12 col-md-12 col-lg-6 row" *ngIf="visualParams.isContentEmpty">
      <app-content-empty [contentEmpty]="contentEmpty"></app-content-empty>
    </div>
    <div #startScroll id="startScrollDetailOrderListDialog"></div>
    <div *ngIf="!visualParams.isContentEmpty" class="asb p-0 col-sm-12 col-md-12 col-lg-8">
      <div *ngIf="!visualParams.isContentEmpty" class="row px-1 shopping-cards-container">
        <div class="col-sm-12 col-md-12 col-lg-12 no-margin no-padding shopping-card-dialog"
          *ngFor="let userDetail of itemsShoppingCard">
          <p class="title-size-3 font-omicron-bold color-omicron mt-2">{{ userDetail.clientName }}: </p>
          <div class="mb-2" *ngFor="let shoppingCard of userDetail.detailsProducts">
            <app-product-card [productCard]="{
                callPlace: whoRequest,
                detailProduct: shoppingCard
              }" [showIvaLegend]="visualParams.showIvaLegend" [isDiscountVisible]="visualParams.isDiscountVisible"
              [isUtility]="visualParams.isUtility && !shoppingCard.isPackage"
              [showAddtoCarButton]="whoRequest !== CallPlacesCompare.metricsPromotion"
              [showDialogDiscount]="visualParams.showDialogDiscount" [showContainerDiscountNoButton]="true"
              [showAsteriskPackages]="cartContentType === cartContentTypeCompare.packagesAndProducts"
              [showFavoriteButton]="showFavoriteButton">
            </app-product-card>
          </div>
        </div>
      </div>

      <div *ngIf="
          whoRequest === callFromPendingOrders! &&
          !isPaymentProcessed &&
          statusOrder !== statusPendingOrder.authorize &&
          paymentInformation.object !== paymentTypeCompare.credit &&
          paymentInformation.object !== paymentTypeCompare.paypal
        " class="updated-prices font-omicron-bold color-orange pb-3 pl-3">
        {{
        paymentInformation.object === paymentTypeCompare.oxxo ||
        paymentInformation.object === paymentTypeCompare.spei
        ? legendBySubjectPrices.subjetcPricesOtherPaymentMethods
        : legendBySubjectPrices.subjetcPricesCard
        }}
      </div>
    </div>
    <div class="info-detail-container col-sm-12 col-md-12 col-lg-4">
      <div class="billing-info row no-margin no-padding" *ngIf="visualParams.isHeader">
        <div class="delivery-direction col-sm-12 col-md-12 col-lg-12 ml-0 mr-0">
          <div class="title-size-3 font-omicron-bold mb-2">
            Información del pedido:
          </div>
          <ng-container *ngIf="isInstitutional && visualParams.showPickedUp && header.storePickup === 0">
            <div class="header-delivered-title font-omicron-bold size-title-tax-data">
              Médico responsable:
            </div>
            <div class="header-delivered-title font-omicron-bold size-title-tax-data">
              {{ header.addressDeliveryId | uppercase }}
            </div>
          </ng-container>
          <div class="header-delivered-title font-omicron-bold size-title-tax-data">
            Dirección de entrega
          </div>
          <div class="header-delivered-title font-omicron-bold size-title-tax-data" *ngIf="
              (visualParams.showPickedUp && header.storePickup === 1) ||
              !visualParams.showPickedUp
            ">
            {{ header.addressDeliveryId | uppercase }}
          </div>
          <div *ngIf="
              (visualParams.showPickedUp && header.storePickup === 1) ||
              !visualParams.showPickedUp
            ">
            <div class="header-delivered-title font-omicron-medium size-title-tax-data"
              *ngFor="let header of header.address">
              <span>{{ header | uppercase }}</span>
            </div>
          </div>
          <div class="font-omicron-bold" *ngIf="visualParams.showPickedUp && header.storePickup === 0">
            Pasaré a las oficinas de
            <span class="color-omicron">OmicronLab</span> por mi pedido.
            <div class="d-flex">
              <img src="assets/icons/ubication.svg" alt="ubication" />
              <div class="d-flex flex-column color-omicron pl-2">
                <p class="mb-0">Dirección</p>
                <p class="mb-0">
                  Del Refugio 4120 Col. Alfareros, Monterrey, N.L., México
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="delivery-direction col-sm-12 col-md-12 col-lg-12 mr-0">
          <div class="header-delivered-title font-omicron-bold size-title-tax-data">
            Datos fiscales
          </div>
          <div class="header-delivered-title font-omicron-medium size-title-tax-data"
            *ngIf="!visualParams.isNeedDataTax">
            {{ legendsProfileTabs.needDataTax }}
          </div>
          <div *ngIf="visualParams.isNeedDataTax">
            <div *ngFor="let taxItem of header.invoiceAddressList;let i = index;"
              [ngClass]=" i===0 ?' header-delivered-title size-title-tax-data font-omicron-bold ' : 'header-delivered-title font-omicron-medium size-title-tax-data' ">
              <span>{{ taxItem | uppercase }}</span>
            </div>
          </div>
        </div>
        <div class="delivery-direction col-sm-12 col-md-12 col-lg-12 mr-0">
          <div class="header-delivered-title font-omicron-bold size-title-tax-data">
            <div class="d-flex justify-content-start align-items-center">
              Forma de {{ visualParams.isNeedDataTax ? 'facturación' : 'entrega'}}
            </div>
          </div>
          <div class="header-delivered-title font-omicron-medium size-title-tax-data">
            <ng-container *ngIf="visualParams.isNeedDataTax">
              {{ header.invoiceType }}
            </ng-container>
            <ng-container *ngIf="!visualParams.isNeedDataTax">
              {{ header.invoiceType === invoiceType.completa ? deliveryType.completa : deliveryType.parcial }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="total-detail-order" *ngIf="visualParams.informationIsloaded">
        <app-totals-description [disable]="visualParams.isLockButton" [totalDescription]="totalDescription"
          (editButton)="editBuyOrder($event)" (acceptButton)="acceptButton($event)"
          [disableCostShipping]="visualParams.isShippingCost" [disableCostDiscount]="visualParams.isdisableCostDiscount"
          [isSmallLetters]="true" [rol]="rol" [orderStatus]="statusOrder" [callPlace]="whoRequest" [disableUtilities]="
            cartContentType !== cartContentTypeCompare.onlyPackages
          " [showAsteriskPackages]="
            cartContentType === cartContentTypeCompare.packagesAndProducts
          " [fullwidth]="true" (printPdfEmitter)="generatePDF()" [shippingCostDiscount]="shipingCostDiscount"
          [shippingCostDiscountAmount]="shipingCostDiscountAmount" [promotionalCode]="promotionalCode">
          <div paymentMethods>
            <div class="padding-payment header-delivered-title font-omicron-bold size-title-tax-data">
              Método de pago
            </div>
            <div class="payment-methods">
              <div class="payment-null font-omicron-medium size-title-tax-data" *ngIf="paymentInfoImage === ''">
                No se cuenta con un método de pago
              </div>
              <div class="info-payment" *ngIf="paymentInfoImage !== ''">
                <app-payment-methods-image [srcImage]="paymentInfoImage"
                  [paymentTypeCredit]="paymentInformation.object">
                </app-payment-methods-image>
                <div class="text text-size-1 font-omicron-bold size-title-tax-data" *ngIf="
                  paymentInformation.cardLastNumbers &&
                  paymentInformation.object !== paymentTypeCompare.credit
                ">
                  <span class="color-blue-omicron font-omicron-bold">{{
                    paymentInformation.cardName
                    }}</span>
                  <span class="color-black font-omicron-bold">{{
                    paymentInformation.cardLastNumbers
                    | hideCard: paymentInformation.brand
                    }}</span>
                </div>
              </div>
            </div>
            <div class="msi-plan text-size-1 font-omicron-medium size-title-tax-data" id="detail-msi-plan" *ngIf="
              paymentInformation.monthlyInstallments &&
              paymentInformation.object === paymentTypeCompare.card
            ">
              <p>
                <span class="color-black">Plan de pago: </span>
                <span class="color-blue-omicron font-omicron-bold">{{ paymentInformation.monthlyInstallments }} meses sin
                  intereses</span>
              </p>
              <p *ngIf="paymentInformation.monthlyAmount">
                <span class="color-black">{{ paymentInformation.monthlyInstallments }} mensualidades de </span>
                <span class="color-black font-omicron-bold">${{ paymentInformation.monthlyAmount | numberNotRound
                  }}</span>
              </p>
            </div>
          </div>
        </app-totals-description>
      </div>
    </div>
  </div>
</div>